module.exports = "<div class=\"gw-grid-row\" ng-show=\"!policyQuoted && !errorInSubmission\">\r\n\t\t<div class=\"gw-col-phone-12 gw-col-tablet-1\"></div>\r\n\t\t<div class=\"gw-col-phone-12 gw-col-tablet-10\">\r\n\r\n\t\t<div  gw-enter-payroll-table></div>\t\r\n\t\t</div>\r\n\t\t<!-- <div class=\"gw-col-phone-12 gw-col-tablet-6\"></div> -->\r\n\r\n\t\t<div class=\"gw-col-phone-12 gw-col-tablet-1\"></div>\r\n\r\n\t</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/views/enterpayroll-details.html
// module id = 799
// module chunks = 0